import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, Play, CreditCard, Shield } from 'lucide-react';

const GuidesSection = () => {
  return (
    <section id="guides" className="py-20 px-4 bg-gradient-to-b from-beige-100 to-brown-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 mb-4">
            <BookOpen className="w-8 h-8 text-brown-700" />
            <h2 className="text-4xl md:text-5xl font-bold text-brown-900">
              Master Online Casino Gaming
            </h2>
          </div>
          <p className="text-xl text-brown-700 max-w-2xl mx-auto">
            Build confidence and improve your gameplay with our comprehensive guides
          </p>
        </div>

        <div className="glass-strong rounded-3xl p-8 md:p-12 mb-8">
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-brown-700 leading-relaxed mb-8">
              Stepping into the world of online casinos can feel overwhelming at first. Which games offer the best odds? 
              How do you claim and use bonuses effectively? What makes a casino truly trustworthy? Our guides break down 
              everything you need to know, from the basics of placing your first bet to advanced strategies that boost your 
              winning potential. We'll walk you through payment methods, explain game mechanics, and help you develop a 
              gaming approach that's both enjoyable and responsible.
            </p>
            <Link
              to="/guides"
              data-discover="true"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-brown-700 to-brown-900 text-white rounded-full font-semibold text-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 group"
            >
              <span>Browse All Guides</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="glass rounded-2xl p-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-brown-600 to-brown-800 rounded-full flex items-center justify-center text-white">
              <Play className="w-8 h-8" />
            </div>
            <h3 className="text-xl font-bold text-brown-900 mb-2">Game Strategies</h3>
            <p className="text-brown-700">Learn winning tactics for slots, blackjack, roulette, and more</p>
          </div>
          <div className="glass rounded-2xl p-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-brown-600 to-brown-800 rounded-full flex items-center justify-center text-white">
              <CreditCard className="w-8 h-8" />
            </div>
            <h3 className="text-xl font-bold text-brown-900 mb-2">Payment Guides</h3>
            <p className="text-brown-700">Understand deposits, withdrawals, and payment security</p>
          </div>
          <div className="glass rounded-2xl p-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-brown-600 to-brown-800 rounded-full flex items-center justify-center text-white">
              <Shield className="w-8 h-8" />
            </div>
            <h3 className="text-xl font-bold text-brown-900 mb-2">Safe Gaming</h3>
            <p className="text-brown-700">Essential tips for responsible and secure casino play</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuidesSection;

